import Popover from './Popover';

export default Popover;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/popover/index.js
// module id = 416
// module chunks = 0